module.exports = __webpack_public_path__ + "img/00037.c582edd7.webp";